var LocalityPage;
(function (LocalityPage) {
    var c;
    var communicator = /** @class */ (function () {
        function communicator() {
            this.receiveMessage = function (event) {
                var eventData = event.data;
                if (eventData.type) {
                    switch (eventData.type) {
                        case "widgetstarted": {
                            $("#eventsBasic .placeholder").remove();
                            break;
                        }
                        case "resize": {
                            if (eventData.hasOwnProperty("height")) {
                                $("#eventsBasic").css("height", eventData.height);
                            }
                            break;
                        }
                    }
                }
                ;
            };
            this.addListeners = function () {
                window.addEventListener("message", this.receiveMessage, false);
            };
        }
        return communicator;
    }());
    function Init(locality) {
        $(function () {
            c = new communicator();
            c.addListeners();
            Common.SetCurrentLocality(locality);
        });
        if ($(".locality-description")) {
            if ($(".locality-description").height() > 90) {
                $(".locality-description").addClass("locality-description-truncated");
            }
            else {
                $("#description-expand").hide();
            }
        }
        $("#description-expand").on("click touchend", function () {
            var desc = $(".locality-description-container").find("p:first");
            if (desc.hasClass("locality-description-truncated")) {
                desc.removeClass("locality-description-truncated");
                $(this).html("<i class='fa fa-minus'></i> Read less");
            }
            else {
                desc.addClass("locality-description-truncated");
                $(this).html("<i class='fa fa-plus'></i> Read more");
            }
        });
        setTimeout(function () {
            if ($(".fb-page:first").find("span").height() == 0) {
                $("#fb-container").hide();
                $("#map-container").removeClass("col-xs-6").addClass("col-xs-12");
            }
        }, 3000);
        PageSetup.InitSearchButton(locality.LocalityID, locality.LocationName);
        $("#saveDesc").on("click touchend", function () {
            var txDescBody = $("#txDescBody").val();
            var localityId = $("#localityId").val();
            var profileId = $("#profileId").val();
            $.ajax({
                type: "POST",
                url: "/api/locations/update",
                data: JSON.stringify({ txDescBody: txDescBody, localityId: localityId, profileId: profileId }),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data) {
                    if (data && data === true) {
                        location.reload();
                    }
                },
                error: function () {
                    console.log("error");
                }
            });
        });
        if ($(".locality-description-wiki").length) {
            var suburb = $(".locality-description-wiki").data("locality");
            var state = $(".locality-description-wiki").data("state");
            $.ajax({
                type: "GET",
                url: "https://en.wikipedia.org/w/api.php?action=query&prop=extracts&format=json&exintro&explaintext&titles=" + suburb + ",%20" + state,
                dataType: 'JSONP',
                cache: false,
                success: function (result) {
                    if (result.query && result.query.pages && result.query.pages[Object.keys(result.query.pages)[0]].extract) {
                        var desc = result.query.pages[Object.keys(result.query.pages)[0]].extract;
                        $(".locality-description-wiki").html(desc);
                    }
                    else {
                        $(".locality-description-wiki").text("We don't have a description for this area. Why not add one?");
                        $("#description-update").show();
                    }
                },
                error: function () {
                    $(".locality-description-wiki").text("We don't have a description for this area. Why not add one?");
                    $("#description-update").show();
                }
            });
        }
    }
    LocalityPage.Init = Init;
})(LocalityPage || (LocalityPage = {}));
